<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="p1bkmk1"></a> Copyright © 2009 by L. Jon Wertheim</p>
<p class="timebreak"> <br/></p>
<p class="left"><span style="font-size: smaller">ALL RIGHTS RESERVED</span></p>
<p class="timebreak"> <br/></p>
<p class="left">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="left"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="left"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Wertheim, L. Jon.<br/>
Blood in the cage : mixed martial arts, Pat Miletich, and the furious rise of the UFC / L. Jon Wertheim.<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 978-0-618-98261-5<br/>
1. Mixed martial arts. 2. Miletich, Patrick Jay, 1968– 3. Martial artists—United States—Biography. 4. UFC (Mixed martial arts event) I. Title.<br/>
<span style="font-size: smaller">GV</span>1102.7.M59<span style="font-size: smaller">W</span>47 2009<br/>
796.815—dc22 2008036764</p>
<p class="timebreak"> <br/></p>
<p class="left">e<span style="font-size: smaller">ISBN</span> 978-0-547-34722-6<br/>
v2.0215</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?1accc648